import { Container, Col } from "react-bootstrap";
import React from "react";
import { IStepsList } from "src/app/components/form/FormikStepper";

export interface ISiloStepModalFormModalForm {
    stepsList?: IStepsList[];
    currentStep?: number;
}

const Stepper = ({ children, currentStep }: any) => {
    const childrenArray = React.Children.toArray(
        children as React.ReactNode
    ) as React.ReactElement<any>[];
    const currentChild = childrenArray[currentStep];
    return <>{currentChild}</>;
};

const siloStepModalForm = (props: ISiloStepModalFormModalForm) => {
    const { currentStep = 0, stepsList } = props;
    return (
        <Container>
            <div
                className="stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid first"
                data-kt-stepper="true"
            >
                <Col>
                    <Stepper currentStep={currentStep}>
                        {stepsList?.map((step, index) => (
                            <React.Fragment key={index}>{step.element}</React.Fragment>
                        ))}
                    </Stepper>
                </Col>
            </div>
        </Container>
    );
};

export default siloStepModalForm;
